import React, { useEffect } from 'react';
import styles from './Toast.module.scss';

const Toast = ({ message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000);

        return () => {
            clearTimeout(timer);
        };
    }, [onClose]);

    if (!message) {
        return null;
    }

    return (
        <div className={`${styles.toast} ${styles[type]}`}>
            <div className={styles.toastContent}>
                <strong>{type === 'success' ? 'Success' : 'Error'}:</strong> {message}
            </div>
            <button onClick={onClose} className={styles.closeButton}>
                <i className="material-icons">close</i>
            </button>
        </div>
    );
};

export default Toast;